export default {
	updateContent(state, response) {
		state.content = Object.assign({}, state.content, response);
	},
	updateCommonContent(state, response) {
		state.commonContent = Object.assign({}, state.commonContent, response);
	}
};
